export default __webpack_public_path__ + "images/FL.4662dee.png";